import { render, staticRenderFns } from "./LaboralRequests.vue?vue&type=template&id=66ba4570&"
import script from "./LaboralRequests.vue?vue&type=script&lang=js&"
export * from "./LaboralRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports